// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DateFns = require("date-fns");
var DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.bs.js");
var PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.bs.js");
var PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.bs.js");

var convertFragment = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_mlsListingTypeV5_decode = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.Utils.mlsListingTypeV5_decode;

var DraftFragment_mlsListingTypeV5_fromString = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_draft_graphql.Utils.mlsListingTypeV5_fromString;

var DraftFragment = {
  mlsListingTypeV5_decode: DraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: DraftFragment_mlsListingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.node, convertFragment$1, fRef);
}

var FormStateFragment_localDraftMlsStatus_decode = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.Utils.localDraftMlsStatus_decode;

var FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState_graphql.Utils.localDraftMlsStatus_fromString;

var FormStateFragment = {
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function useIsValid(draft, formState) {
  var draft$1 = use(draft);
  var formState$1 = use$1(formState);
  var match = PropertyWizardFormRelay.Context.use();
  var mode = match.mode;
  var match$1 = draft$1.draftProperty.mlsListingType;
  var match$2 = formState$1.mlsStatus;
  var exit = 0;
  var exit$1 = 0;
  switch (match$2) {
    case "OnMls" :
    case "OnMlsButAllowed" :
        exit$1 = 2;
        break;
    default:
      exit = 1;
  }
  if (exit$1 === 2) {
    if (typeof mode !== "object") {
      if (match$1 !== "ACTIVE") {
        return {
                NAME: "Error",
                VAL: "alreadyOnMlsAndNotActive"
              };
      }
      exit = 1;
    } else {
      switch (mode.TAG) {
        case "Edit" :
            if (match$1 === mode.savedMlsListingType) {
              return "Valid";
            }
            exit = 1;
            break;
        case "Rebroadcast" :
        case "BroadcastQuietSeller" :
            exit = 1;
            break;
        
      }
    }
  }
  if (exit === 1) {
    if (match$1 === undefined) {
      return {
              NAME: "Error",
              VAL: "required"
            };
    }
    var exit$2 = 0;
    if (!(match$1 === "COMING_SOON" || match$1 === "ACTIVE" || match$1 === "OFF_MLS")) {
      return "Valid";
    }
    switch (match$1) {
      case "ACTIVE" :
          return "Valid";
      case "COMING_SOON" :
      case "OFF_MLS" :
          exit$2 = 2;
          break;
      
    }
    if (exit$2 === 2) {
      var exit$3 = 0;
      switch (match$2) {
        case "OnMls" :
        case "OnMlsButAllowed" :
            exit$3 = 3;
            break;
        default:
          return "Valid";
      }
      if (exit$3 === 3) {
        if (typeof mode !== "object" || mode.TAG !== "Edit") {
          return "Valid";
        } else {
          return {
                  NAME: "Error",
                  VAL: "cannotChangeMlsListingTypeBecausePropertyIsOnMls"
                };
        }
      }
      
    }
    
  }
  
}

var MLSListingType = {
  DraftFragment: DraftFragment,
  FormStateFragment: FormStateFragment,
  useIsValid: useIsValid
};

var convertFragment$2 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.node, convertFragment$2, fRef);
}

var DraftFragment_mlsListingTypeV5_decode$1 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.Utils.mlsListingTypeV5_decode;

var DraftFragment_mlsListingTypeV5_fromString$1 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_draft_graphql.Utils.mlsListingTypeV5_fromString;

var DraftFragment$1 = {
  mlsListingTypeV5_decode: DraftFragment_mlsListingTypeV5_decode$1,
  mlsListingTypeV5_fromString: DraftFragment_mlsListingTypeV5_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

var convertFragment$3 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.node, convertFragment$3, fRef);
}

var FormStateFragment_localDraftMlsStatus_decode$1 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.Utils.localDraftMlsStatus_decode;

var FormStateFragment_localDraftMlsStatus_fromString$1 = PropertyWizardFormRelayValidatorsMLSTimingOnMLSAt_formState_graphql.Utils.localDraftMlsStatus_fromString;

var FormStateFragment$1 = {
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode$1,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function useIsValid$1(draft, formState) {
  var match = PropertyWizardFormRelay.Context.use();
  var mode = match.mode;
  var draft$1 = use$2(draft);
  var formState$1 = use$3(formState);
  var today = CalendarDate.toLocalDate(CalendarDate.today(DateFnsTz.Timezone.make(draft$1.timeZone)));
  var match$1 = draft$1.draftProperty;
  var match$2 = formState$1.mlsStatus;
  var exit = 0;
  var exit$1 = 0;
  var exit$2 = 0;
  if (typeof mode !== "object") {
    var onMlsAt = match$1.onMlsAt;
    var exit$3 = 0;
    switch (match$2) {
      case "OnMls" :
      case "OnMlsButAllowed" :
          exit$3 = 5;
          break;
      default:
        exit$2 = 4;
    }
    if (exit$3 === 5) {
      if (onMlsAt === undefined) {
        return {
                NAME: "Error",
                VAL: "alreadyOnMlsAndAfterToday"
              };
      }
      var onMlsAt$1 = Caml_option.valFromOption(onMlsAt);
      if (DateFns.isSameDay(CalendarDate.toLocalDate(onMlsAt$1), today) || DateFns.isBefore(CalendarDate.toLocalDate(onMlsAt$1), today)) {
        return "Valid";
      } else {
        return {
                NAME: "Error",
                VAL: "alreadyOnMlsAndAfterToday"
              };
      }
    }
    
  } else {
    exit$2 = 4;
  }
  if (exit$2 === 4) {
    var match$3 = match$1.mlsListingType;
    if (match$3 === undefined) {
      return ;
    }
    if (match$3 === "COMING_SOON" || match$3 === "ACTIVE" || match$3 === "OFF_MLS") {
      if (match$3 === "OFF_MLS") {
        return "Valid";
      }
      exit$1 = 3;
    } else {
      exit$1 = 3;
    }
  }
  if (exit$1 === 3) {
    if (typeof mode !== "object") {
      exit = 2;
    } else {
      switch (mode.TAG) {
        case "Edit" :
        case "Rebroadcast" :
            exit = 1;
            break;
        case "BroadcastQuietSeller" :
            exit = 2;
            break;
        
      }
    }
  }
  switch (exit) {
    case 1 :
        var match$4 = match$1.mlsListingType;
        if (match$4 === undefined) {
          return ;
        }
        if (!(match$4 === "COMING_SOON" || match$4 === "ACTIVE" || match$4 === "OFF_MLS")) {
          return ;
        }
        switch (match$4) {
          case "ACTIVE" :
          case "COMING_SOON" :
              if (match$1.onMlsAt !== undefined) {
                return "Valid";
              } else {
                return {
                        NAME: "Error",
                        VAL: "required"
                      };
              }
          case "OFF_MLS" :
              return ;
          
        }
    case 2 :
        var match$5 = match$1.mlsListingType;
        if (match$5 === undefined) {
          return ;
        }
        var exit$4 = 0;
        if (!(match$5 === "COMING_SOON" || match$5 === "ACTIVE" || match$5 === "OFF_MLS")) {
          return ;
        }
        switch (match$5) {
          case "ACTIVE" :
          case "COMING_SOON" :
              exit$4 = 3;
              break;
          case "OFF_MLS" :
              return ;
          
        }
        if (exit$4 === 3) {
          var onMlsAt$2 = match$1.onMlsAt;
          if (onMlsAt$2 === undefined) {
            return {
                    NAME: "Error",
                    VAL: "required"
                  };
          }
          var onMlsAt$3 = Caml_option.valFromOption(onMlsAt$2);
          if (DateFns.isSameDay(CalendarDate.toLocalDate(onMlsAt$3), today) || DateFns.isAfter(CalendarDate.toLocalDate(onMlsAt$3), today)) {
            return "Valid";
          } else {
            return {
                    NAME: "Error",
                    VAL: "mustBeTodayOrAfter"
                  };
          }
        }
        break;
    
  }
}

var OnMLSAt = {
  DraftFragment: DraftFragment$1,
  FormStateFragment: FormStateFragment$1,
  useIsValid: useIsValid$1
};

function useIsValid$2() {
  return "Valid";
}

var WillShow = {
  useIsValid: useIsValid$2
};

function useIsValid$3() {
  return "Valid";
}

var WillAcceptOffers = {
  useIsValid: useIsValid$3
};

var convertFragment$4 = PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTiming_draft_graphql.node, convertFragment$4, fRef);
}

var DraftFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

var convertFragment$5 = PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsMLSTiming_formState_graphql.node, convertFragment$5, fRef);
}

var FormStateFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function use$6(draft, formState) {
  var draft$1 = use$4(draft);
  var formState$1 = use$5(formState);
  var onMlsValid = useIsValid$1(draft$1.fragmentRefs, formState$1.fragmentRefs);
  var mlsListingTypeValid = useIsValid(draft$1.fragmentRefs, formState$1.fragmentRefs);
  var willShowValid = "Valid";
  var willAcceptOffersValid = "Valid";
  return PropertyWizardRelayUtils.FormUtils.allValid([
              PropertyWizardRelayUtils.FormUtils.optResultToDummyStringResult(onMlsValid),
              PropertyWizardRelayUtils.FormUtils.optResultToDummyStringResult(mlsListingTypeValid),
              willShowValid,
              willAcceptOffersValid
            ]);
}

var FormUtils;

exports.FormUtils = FormUtils;
exports.MLSListingType = MLSListingType;
exports.OnMLSAt = OnMLSAt;
exports.WillShow = WillShow;
exports.WillAcceptOffers = WillAcceptOffers;
exports.DraftFragment = DraftFragment$2;
exports.FormStateFragment = FormStateFragment$2;
exports.use = use$6;
/* date-fns Not a pure module */
